module.exports = __webpack_public_path__ + "resources/img/img_experdb4.e5283c5316c1591769953f95987c00b1.png";